export default {
  users: [],
  user: {
    simulacao_recorte: {
      regioes: [],
      estados: [],
      municipios: [],
    },
  },
  pagination: {
    current_page: 1,
    per_page: 15,
  },
};
